export default __webpack_public_path__ + "static/media/navigation.89d8eecf.yaml";